import {
  AssistenzaPratichePayload,
  AvailableProductResponse,
  ProductPriceResponse,
  ProductSupportResponse,
} from "./product.models";
import { envConfig } from "../config/envconfig";

import responseCoperture from "../../mocks/responseCoperture.json";
import responseListinoPrezzi from "../../mocks/responseListinoPrezzi.json";
import responseAssistenzaPratiche from "../../mocks/responseAssistenzaPratiche.json";
import recaptcha from "../recaptcha";
class ProductApi {
  constructor() { }


  /**
   * Verifica copertura per un determinato CAP.
   *
   * Il cap viene specificato come query param ed è obbligatorio.
   * I parametri idMestiere e idProdotto vengono specificati come query param e sono opzionali, tuttavia almeno uno dei due deve essere specificato.
   *
   * Non è possibile valorizzare contemporanemente idMestiere e idProdotto.
   *
   * @param string - cap
   * @param string - captcha
   * @param string - idProdotto
   * @param string - idMestiere
   * @returns
   */
  async checkProductCoverage(
    cap: string,
    idProdotto?: string,
    idMestiere?: string
  ) {
    return new Promise<AvailableProductResponse>(async (resolve, reject) => {
      const captcha = await recaptcha.getToken();
      //Query params
      let queryParams = new URLSearchParams();
      queryParams.append("cap", cap);
      if (idProdotto && !idMestiere) {
        queryParams.append("idProdotto", idProdotto);
      }
      if (idMestiere && !idProdotto) {
        queryParams.append("idMestiere", idMestiere);
      }

      //Fetch Init
      let requestInit: RequestInit = {
        method: "GET",
      };

      // Headers
      requestInit.headers = {
        ...envConfig.HEADERS,
        "Content-Type": "application/json",
        "g-recaptcha-response": captcha
      };
      if (envConfig.globalMockEnabled) {
        console.log(
          "%cRisposta mockata!",
          "color:white; background-color: red; padding: 3px; font-size: 12px;"
        );
        console.log(responseCoperture);
        resolve(responseCoperture);
        return;
      }
      fetch(`${envConfig.APIPATH}/coperture?${queryParams}`, requestInit)
        .then((response: Response) => {
          if (response.ok) {
            resolve(response.json());
          } else {
            console.log(
              `%cNot ok! Status: [${response?.status ?? 0}] ${response?.statusText}`,
              "color:white; background-color: red; padding: 3px; font-size: 12px;"
            );
            response?.json().then(res => {
              console.log("Response: ", (res));
            })

            if (envConfig.fallbackMock) {
              console.log(
                "%cRisposta mockata!",
                "color:white; background-color: red; padding: 3px; font-size: 12px;"
              );
              console.log(responseCoperture);
              resolve(responseCoperture);
            }
            else
              resolve(null);
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  /**
   * Richiesta prezzo prodotto
   * @param idProdotto
   * @returns
   */
  async getProductPrice(cap: string, idProdotto: string, idCatalogo: string) {
    return new Promise<ProductPriceResponse | null>(async (resolve, reject) => {
      const captcha = await recaptcha.getToken();

      //Query params
      let queryParams = new URLSearchParams();
      queryParams.append("cap", cap);
      queryParams.append("idProdotto", idProdotto);
      queryParams.append("codiceCatalogo", idCatalogo);

      //Fetch Init
      let requestInit: RequestInit = {
        method: "GET",
      };

      // Headers
      requestInit.headers = {
        "Content-Type": "application/json",
      };
      if (envConfig.HEADERS) {
        requestInit.headers = {
          ...envConfig.HEADERS, "Content-Type": "application/json",
          "g-recaptcha-response": captcha
        };
      }
      if (envConfig.globalMockEnabled) {
        console.log(
          "%cRisposta mockata!",
          "color:white; background-color: red; padding: 3px; font-size: 12px;"
        );
        resolve(responseListinoPrezzi);
        return;
      }
      fetch(`${envConfig.APIPATH}/listinoPrezzi?${queryParams}`, requestInit)
        .then((response) => {
          if (response.ok) {
            resolve(response.json());
          } else {
            console.log(
              `%cNot ok! Status: [${response?.status ?? 0}] ${response?.statusText}`,
              "color:white; background-color: red; padding: 3px; font-size: 12px;"
            );
            response?.json().then(res => {
              console.log("Response: ", (res));
            })

            if (envConfig.fallbackMock) {
              console.log(
                "%cRisposta mockata!",
                "color:white; background-color: red; padding: 3px; font-size: 12px;"
              );
              resolve(responseListinoPrezzi);
            }
            else
              resolve(null);
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  }
  async postSupportData(payload: AssistenzaPratichePayload): Promise<ProductSupportResponse> {
    return new Promise<ProductSupportResponse | null>(async (resolve, reject) => {
      const captcha = await recaptcha.getToken();
      if (!payload) {
        console.error("Payload can't be null");
      }
      //Fetch Init
      let requestInit: RequestInit = {
        method: "POST",
      };

      // Headers
      requestInit.headers = {
        "Content-Type": "application/json",
      };
      if (envConfig.HEADERS) {
        requestInit.headers = {
          ...envConfig.HEADERS, "Content-Type": "application/json",
          "g-recaptcha-response": captcha
        };
      }

      requestInit.body = JSON.stringify(payload);

      if(envConfig.globalMockEnabled) {
        console.log(
          "%cRisposta mockata!",
          "color:white; background-color: red; padding: 3px; font-size: 12px;"
        );
        resolve(responseAssistenzaPratiche);
        return;
      }
      fetch(`${envConfig.APIPATH}/assistenza/pratiche`, requestInit)
        .then((response) => {
          if (response.ok) {
            resolve(response.json());
          } else {
            console.log(
              `%cNot ok! Status: [${response?.status ?? 0}] ${response?.statusText}`,
              "color:white; background-color: red; padding: 3px; font-size: 12px;"
            );
            response?.json().then(res => {
              console.log("Response: ", (res));
            })

            if (envConfig.fallbackMock) {
              console.log(
                "%cRisposta mockata!",
                "color:white; background-color: red; padding: 3px; font-size: 12px;"
              );
              resolve(responseAssistenzaPratiche);
            }
            else
              resolve(null);
          }
        })
        .catch((e) => {
          reject(e);
        });
    });
  }


}

export default new ProductApi();
